import { useSwrManagement } from "~/hooks/useSwrManagement";
import { confirmResetPassword } from "../services/confirmResetPassword";
import { ResetPasswordConfirmStatus } from "../types/confirmResetPassword";
const fetcher = async (code?: string) => {
  if (!code) {
    return;
  }

  const result = await confirmResetPassword({ code });
  return result;
};

export const useConfirmResetPassword = (code?: string) => {
  const swrKey = createSWRKey(code);

  const { data, error } = useSwrManagement({
    swrKey,
    fetcher: () => fetcher(code),
    swrConfig: {
      revalidateOnFocus: false,
      errorRetryCount: 0,
    },
    disableNotification: true,
  });

  if (error) {
    const errorMessage = (error as Error)?.message;
    const isValidStatus = (
      Object.values(ResetPasswordConfirmStatus) as string[]
    ).includes(errorMessage);

    return {
      messageCode: isValidStatus
        ? (errorMessage as ResetPasswordConfirmStatus)
        : "UnexpectedError",
    };
  }
  return data;
};

const createSWRKey = (code?: string) => {
  return ["confirm-reset-code", code].join("|");
};
